module.exports = __webpack_public_path__ + "img/green-circle-table-4.7a4d68d9.png";